import { render } from "./GearIcon.vue?vue&type=template&id=bf9b1006"
import script from "./GearIcon.vue?vue&type=script&lang=js"
export * from "./GearIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__